export default "__VITE_ASSET__4Y8ru6uK__"